import { render } from "./section-three.vue?vue&type=template&id=d72d14c2&scoped=true"
const script = {}

import "./section-three.vue?vue&type=style&index=0&id=d72d14c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72d14c2"]])

export default __exports__